//------------------------------------------------------ funciones
import {
  subscribeTable,
  createRow,
  updateRow,
  deleteRow,
} from "../supabaseRealtime";
import { cacheStore } from "../cache";
import {
  enriquecerPersonas,
  getPersonaPorId,
  getChoferes,
  getChoferesLarga,
  getChoferesMovimiento as getChoferesMov,
  getChoferesFleteros as getFleteros,
  getMecanicos,
  getAdministrativos,
  getSerenos,
} from "../../shared/personas.js";

const TABLA = "personas";

// Realtime para listado
export const subscribePersonas = (callback) => {
  return subscribeTable(TABLA, (personas) => {
    const empresas = cacheStore.empresas?.data || [];
    callback(enriquecerPersonas(personas, empresas));
  });
};

// se re-exportan con los MISMOS nombres que ya usaba store.js y los componentes,
// para no tener que tocar nada más arriba en la cadena.
export {
  getPersonaPorId,
  getChoferes,
  getChoferesLarga,
  getChoferesMov,
  getFleteros,
  getMecanicos,
  getAdministrativos,
  getSerenos,
};

// Metodos (escritura, ahora vía Supabase)
export const createPersona = ({ id, ...data }) => createRow(TABLA, id, data);
export const updatePersona = (id, data) => updateRow(TABLA, id, data);
export const deletePersona = (id) => deleteRow(TABLA, id);
